import { render, staticRenderFns } from "./qaitemoption.vue?vue&type=template&id=5595091a&"
import script from "./qaitemoption.vue?vue&type=script&lang=js&"
export * from "./qaitemoption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports